// Enumerato nel quale si devono inserire tutte le CP che gestiremo
export enum CustomPageType {
    CARDIOLOGY_VISIT,
    STANDALONE,
    TELECONSULTATION,
    TELEMONITORING_VISIT,
    ULTRASOUND,
    NRE
}
